import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import Fab from "material-ui/FloatingActionButton";
import Check from "material-ui/svg-icons/navigation/check";
import { TextField } from "redux-form-material-ui";
import { connect } from "react-redux";

import { maxLength, email, validators, required } from "../services/form";
import { checkPrivileges } from "../auth/privileges";
import auth from "../auth/constants";
import { renderMerchantHeaderInfos } from "./utils";
import { merchantBillingUpdate } from "./actions";

import "./common.css";

class MerchantBilling extends Component {
  componentDidMount() {}

  render() {
    const {
      handleSubmit,
      submitCb,
      merchantCode,
      merchantLibelle,
      mainResortLibelle,
      user
    } = this.props;
    const submit = values => submitCb(merchantCode, values);
    return (
      <div className="card-container">
        <div className="card">
          {renderMerchantHeaderInfos(
            checkPrivileges(user.privileges, auth.DISPLAY_MERCHANT_HEADER),
            merchantLibelle,
            mainResortLibelle
          )}
          <div className="title">Informations pour la facturation</div>
          <div className="inner">
            <span className="help">
              Ces données sont communiquées à SAGE via le flux Tiers.
            </span>
            <form onSubmit={handleSubmit(submit)}>
              <div className="fieldset">
                <Field
                  name="name"
                  floatingLabelText="Intitulé"
                  component={TextField}
                  validate={validators([required, maxLength(35)])}
                />
                <Field
                  name="address"
                  floatingLabelText="Adresse"
                  component={TextField}
                  validate={maxLength(35)}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="address2"
                  floatingLabelText="Complément"
                  component={TextField}
                  validate={maxLength(35)}
                />
                <Field
                  name="postalCode"
                  floatingLabelText="Code postal"
                  component={TextField}
                  validate={maxLength(9)}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="city"
                  floatingLabelText="Ville"
                  component={TextField}
                  validate={maxLength(35)}
                />
                <Field
                  name="country"
                  floatingLabelText="Pays"
                  component={TextField}
                  validate={maxLength(35)}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="siret"
                  floatingLabelText="N° de siret"
                  component={TextField}
                  validate={maxLength(14)}
                />
                <Field
                  name="identifier"
                  floatingLabelText="Numéro de TVA"
                  component={TextField}
                  validate={maxLength(25)}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="codeApe"
                  floatingLabelText="Code APE"
                  component={TextField}
                  validate={maxLength(7)}
                />
                <div className="field-spacer" />
              </div>
              <div className="fieldset">
                <Field
                  name="phone"
                  floatingLabelText="Phone"
                  component={TextField}
                  validate={maxLength(21)}
                />
                <Field
                  name="fax"
                  floatingLabelText="Télecopie"
                  component={TextField}
                  validate={maxLength(21)}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="email"
                  floatingLabelText="Email"
                  component={TextField}
                  validate={validators([maxLength(69), email])}
                />
                <Field
                  name="contact"
                  floatingLabelText="Contact"
                  component={TextField}
                  validate={maxLength(35)}
                />
              </div>
              <Fab type="submit" className="fab" secondary>
                <Check />
              </Fab>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

MerchantBilling = reduxForm({
  form: "MerchantBilling",
  enableReinitialize: true
})(MerchantBilling);

/********* Container part */

const mapStateToProps = state => ({
  initialValues: state.merchant.detail.billing,
  merchantCode: state.merchant.detail.code,
  merchantLibelle: state.merchant.detail.libelle,
  mainResortLibelle: state.merchant.detail.mainResortLibelle,
  user: state.app.auth.user
});

const mapDispatchToProps = dispatch => ({
  submitCb: function(code, values) {
    const {
      name,
      address,
      address2,
      postalCode,
      city,
      country,
      siret,
      identifier,
      codeApe,
      phone,
      fax,
      email,
      contact
    } = values;
    dispatch(
      merchantBillingUpdate(
        code,
        name,
        address,
        address2,
        postalCode,
        city,
        country,
        siret,
        identifier,
        codeApe,
        phone,
        fax,
        email,
        contact
      )
    );
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MerchantBilling);



// WEBPACK FOOTER //
// ./src/merchant/Billing.js